import { CrystalBridgeFooter } from "@snpjs/crystalbridge";

export const Footer: React.FC = () => {
  const packageInfo = require("../../../package.json");
  return (
    <CrystalBridgeFooter rightElement={"Version " + packageInfo.version} />
  );
};
